import { applicationPortalDialog as fdy } from "./foundry-parts.generated";
/**
 * @fileoverview AppPortalCategoryHeader — section heading inside
 * AppPortalNavigation (e.g. "Platform apps", "Promoted apps"). Optional
 * right-side action (e.g. an "Add" button for Promoted apps).
 *
 * Foundry mapping: `application-portal-dialog__header-container`.
 */

import type { ReactNode } from "react";

interface AppPortalCategoryHeaderProps {
  title: string;
  /** Optional right-aligned action (Blueprint button or link). */
  action?: ReactNode;
  className?: string;
}

export function AppPortalCategoryHeader({ title, action, className }: AppPortalCategoryHeaderProps) {
  return (
    <div data-testid="app-portal-category-header" className={[fdy["header-container"], "bp-app-portal-category-header", className].filter(Boolean).join(" ")}>
      <h2 className={`${fdy["header@1iafdj1"]} bp6-heading bp6-text-muted bp-app-portal-category-header-title`}>{title}</h2>
      {action}
    </div>
  );
}
